export const TESTNET_ADDRESS = {
  BUSD: '0x318714c22f4dD71b3aBDDDc297cfCc4E547cB017',
  BBET: '0xbB7D5F5A4A246e5A08C0e33d9FcCe97c3afd1181',
  XBT: '0x0D1429cAd73BF843462cb45aCa34068458Df5d29',
  STAKING: '0x3bF2eE3571352D1885789ed873CC48506ed11157'
};
